import React from "react";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Trans } from "react-i18next";
import SharePictureSets from "../MyAccount/SharePictureSets";
const useStyles = makeStyles((theme) => {
    console.log("The theme is", theme);
    return {
        container: {
            backgroundColor: theme.palette.primary.light,
            padding: theme.spacing(6),
            "& h2": {
                color: theme.palette.primary.dark,
                marginTop: 0,
            },
        },
    };
});
const SharePictureSetsBox = () => {
    const [showShareDialog, setShowShareDialog] = React.useState(false);
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.container },
            React.createElement("h2", null,
                React.createElement(Trans, null, "Share pictures with friends and family")),
            React.createElement("p", null,
                React.createElement(Trans, null, "We will send an invitation to the recipients' email address.")),
            React.createElement(Button, { variant: "contained", color: "primary", fullWidth: true, onClick: () => setShowShareDialog(true) },
                React.createElement(Trans, null, "Share pictures"))),
        showShareDialog && (React.createElement(SharePictureSets, { onClose: () => setShowShareDialog(false) }))));
};
export default SharePictureSetsBox;
